import { defaultVehicle, Vehicle } from 'models'
import { UniversalVehicle } from 'models/universalData'
import { formatDateIsoToFr } from '../format'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isValidVehicle = (line: any): line is Vehicle => {
  return (
    line &&
    typeof line === 'object' &&
    line.status &&
    line.vehiclePartial &&
    line.vehicleDetail &&
    line.information &&
    line.pricing
  )
}

const extractUniversalVehicle = (line: Vehicle) => {
  if (!isValidVehicle(line)) {
    console.warn('Invalid vehicle payload received:', line)
    const result: UniversalVehicle = {
      blockingReason: '-',
      nbJ: '-',
      no: '-',
      licensePlate: '-',
      bodyType: '-',
      normalVersion: '-',
      make: '-',
      type: '-',
      proprietaireDebiteur: 'TBD',
      dateProduction: '-',
      dateDelivery: '-',
      locationLocationName: '-',
      pickupLocationName: '-',
      auctionStatus: '-',
      administrativeStatus: '-',
      generalStatus: '-',
      logisticStatus: '-',
      auctionStartDateTime: '-',
      entityId: '-',
      vin: '-',
      dateFirstReg: '-',
      color: '-',
      typeRegDoc: '-',
      fuelType: '-',
      bodyTypeRegDoc: '-',
      numberOfSeats: null,
      equipments: [],
      typeSpare: '-',
      version: '-',
      taxHp: null,
      mileage: null,
      documents: [],
      photos: [],
      estimationApporteur: null,
      coteArgusKm: null,
      coteArgusPriceDate: null,
      coteMarche: null,
      providedMileage: null,
      providedFRE: '-',
      reserveTTCHF: null,
      dateCreationDossier: '-',
      registrationCertificateReceivedDate: '-',
      receiptDate: '-',
      referenceVendeur: '-',
      observationsVendeur: null,
      noteExt: null,
      noteInt: null,
      noteCT: null,
      noteBilanExpert: null,
    }
    return result
  }

  const universalData: UniversalVehicle = {
    blockingReason: line.status?.blockingReason ?? '-',
    nbJ: line.information?.stockInElapsedDays ?? '-',
    no: line.no ?? '-',
    licensePlate: line.vehiclePartial?.licensePlate ?? '-',
    bodyType: line.vehiclePartial?.bodyType ?? '-',
    type: line.vehiclePartial?.type ?? '-',
    dateProduction: line.vehiclePartial?.dateProduction ?? '-',
    dateDelivery: line.vehiclePartial?.dateDelivery ?? '-',
    vin: line.vehiclePartial?.vin ?? '-',
    dateFirstReg: line.vehiclePartial?.dateFirstReg ?? '-',
    color: line.vehiclePartial?.color ?? '-',
    typeRegDoc: line.vehiclePartial?.typeRegDoc ?? '-',
    fuelType: line.vehiclePartial?.fuelType ?? '-',
    bodyTypeRegDoc: line.vehiclePartial?.bodyTypeRegDoc ?? '-',
    equipments: line.vehiclePartial?.equipments ?? [],
    normalVersion: line.vehicleDetail?.normalVersion ?? '-',
    make: line.vehicleDetail?.make ?? '-',
    numberOfSeats: line.vehicleDetail?.numberOfSeats ?? 0,
    typeSpare: line.vehicleDetail?.typeSpare ?? '-',
    version: line.vehicleDetail?.version ?? '-',
    taxHp: line.vehicleDetail?.taxHp ?? 0,
    proprietaireDebiteur: 'TBD',
    locationLocationName: line.location?.locationName ?? '-',
    pickupLocationName: line.pickupLocation?.locationName ?? '-',
    auctionStatus: line.status?.auctionStatus ?? '-',
    administrativeStatus: line.status?.administrativeStatus ?? '-',
    generalStatus: line.status?.generalStatus ?? '-',
    logisticStatus: line.status?.logisticStatus ?? '-',
    auctionStartDateTime: line.auction?.auctionStartDateTime
      ? formatDateIsoToFr(line.auction.auctionStartDateTime)
      : '-',
    entityId: line.entityId ?? '-',
    mileage: line.information?.mileage ?? 0,
    providedMileage: line.information?.mileage ?? 0,
    dateCreationDossier: line.information?.dateCreationDossier ?? '-',
    registrationCertificateReceivedDate:
      line.information?.registrationCertificateReceivedDate ?? '-',
    receiptDate: line.information?.receiptDate ?? '-',
    referenceVendeur: line.vendorInformation?.referenceVendeur ?? '-',
    observationsVendeur: line.information?.observationsVendeur ?? null,
    noteExt: line.information?.noteExt ?? null,
    noteInt: line.information?.noteInt ?? null,
    noteCT: line.information?.noteCT ?? null,
    noteBilanExpert: line.information?.noteBilanExpert ?? null,
    documents: line.documents ?? [],
    photos: line.photos ?? [],
    estimationApporteur: line.pricing?.estimationApporteur ?? null,
    coteArgusKm: line.pricing?.coteArgusKm ?? null,
    coteArgusPriceDate: line.pricing?.coteArgusPriceDate ?? null,
    coteMarche: line.pricing?.coteMarche ?? null,
    providedFRE: line.vendorInformation?.providedFRE ?? null,
    reserveTTCHF: line.pricing?.reserveTTCHF ?? null,
  }

  return universalData
}

const defaultUniversalVehicle = extractUniversalVehicle(defaultVehicle)

const extractUniversalVehicles = (data: Array<Vehicle>) => {
  return data.map((vh: Vehicle) => extractUniversalVehicle(vh))
}

export { extractUniversalVehicle, extractUniversalVehicles }
export { defaultUniversalVehicle }
